const SET_LOADING = "@prepayment/setLoading";
const CREATE_PRE_PAYMENT = "@prepayment/createPrePayment";
const CREATE_PRE_PAYMENT_SUCCESS = "@prepayment/createPrePaymentSuccess";

export { SET_LOADING, CREATE_PRE_PAYMENT, CREATE_PRE_PAYMENT_SUCCESS };
